/* src/app/modules/search/components/doc-view/components/doc-viewer/doc-viewer.component.scss */
.doc-viewer-container {
  height: calc(100vh - var(--topNav-height) - 4.5rem);
  margin: 0px 0.1rem;
  margin-top: 0.5rem;
}
.doc-viewer-container ::ng-deep .p-progress-spinner-circle {
  stroke: var(--primary-color) !important;
}
.doc-viewer-preview {
  height: 100vh !important;
  margin: 0 !important;
}
.doc-viewer-image ::ng-deep img {
  max-height: 100vh;
}
/*# sourceMappingURL=doc-viewer.component.css.map */
